// extracted by css-extract-rspack-plugin
export default {"cls1":"Feed-cls1_wWF","cls2":"Feed-cls2_Hst Feed-cls1_wWF"};